export default __webpack_public_path__ + "static/media/bg-pakiki-landing.beb9f89d.avif";